import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHRBackend from 'i18next-xhr-backend';

i18next
  .use(XHRBackend)
  .use(LanguageDetector)
  .init(
    {
      fallbackLng: 'ru',
      lng: 'ru',
      debug: true,
      ns: ['main'],
      defaultNS: 'main',
      backend: {
        loadPath:
          '../../../wp-content/plugins/light-global-theme-addon/locales/{{lng}}/{{ns}}.json',
      },
    },
    (err, t) => {
      if (err) return console.log('something went wrong loading', err);
      console.log('i18next is ready');
      return t;
    }
  );

export default i18next;
